import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
// import * as _redux from "./redux";
// import axios from "axios";
import store, { persistor } from "./redux/store";


// _redux.setupAxios(axios, store);


const root = createRoot(document.getElementById('root'));
root.render(<HelmetProvider><App store = {store} persistor={persistor} /></HelmetProvider>);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
